"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearUndefined = void 0;
/**
 * Generate an object from an object with removed undefined property
 * @param obj
 * @returns
 */
function clearUndefined(obj) {
    return Object.entries(obj).reduce((cleaned, [key, value]) => (value !== undefined ? Object.assign(cleaned, { [key]: value }) : cleaned), {});
}
exports.clearUndefined = clearUndefined;
//# sourceMappingURL=clear.js.map